document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var video = document.querySelector('.jl-how__video video');
    var container = document.querySelector('.jl-how__video');
    if (!video || !container) return;

    container.style.position = 'relative';

    var btn = document.createElement('button');
    btn.innerHTML = '⏸';
btn.style.cssText = 'position:absolute;top:16px;right:16px;z-index:9999;background:rgba(0,0,0,0.6);border:1px solid #c9a84c;color:#c9a84c;font-size:18px;width:44px;height:44px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;';

    btn.addEventListener('click', function() {
      if (video.paused) {
        video.play();
        btn.innerHTML = '⏸';
      } else {
        video.pause();
        btn.innerHTML = '▶';
      }
    });

    container.appendChild(btn);
  }, 1500);
});
